/* ========================== */  
/* ========= import ========= */  
/* ========================== */  

/* ====== React ====== */
import React from "react";
/* ====== CSS ====== */
import styled from 'styled-components';
/* ====== Component Js/Jsx ====== */
import { assets } from '03CommonApiParts/Configuration';
import { InputErrorMessage } from "02CommonUiParts/TableParts/InputErrorMessage";
/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */  

/* ====== Styled Components ====== */
/* ------　テキストフィールド ------*/
const Sinput = styled.input`//インプット
    padding: 0px 5px;
    margin: 2px 0;
    width:${props=>props.width};
    border: solid 1px ${assets().color.border};
    border-radius:3px;
    &:focus{
        outline: solid 1.5px #007BC3;
    };
    box-sizing: content-box;
`;

const Slabel = styled.label`//インプットのラベル
    position: absolute;
    left: 0px;
    margin: 3px 0;
    color: ${assets().color.gray};
    pointer-events: none;
    background-color: white;
    padding:0 3px;
    transform: scale(0.8, 0.8);
`;
const SinputBox = styled.div`
    position: relative;
    border-radius: 3px;
`;
const SoptionRange = styled.option`//選択肢（オプション）
    position: relative;
    display: block;
    padding: 0 22px;
    border-bottom: 1px solid #b5b5b5;
    font-size: ${assets().size.baseText};
    font-weight: bold;
    line-height: 20px;
    cursor: pointer;
    transition: all .4s ease-in-out;
`;
/* How To Use 
 <InputSearchFieldA 
    id={item.id}
    label={item.name}
    maxLength={item.maxLength}
    placeholder={item.placeholder}
    width={item.width}
    pattern='code'
    register={register(`${payload}.${item.id}`,
    {
        required: item.required?CFArrayFount(inputCheckMaster.list,'value','required').label:'',  
        minLength: { value:item.minLength?item.minLength:'',message:CFArrayFount(inputCheckMaster.list,'value','min').label},  
        require:true,
        pattern: {
                    value: item.pattern ? CFArrayFount(patternCheckMaster.list,'value',item.pattern).pattern:CFArrayFount(patternCheckMaster.list,'value','space').pattern,
                    message: item.pattern ? CFArrayFount(patternCheckMaster.list,'value',item.pattern).label:CFArrayFount(patternCheckMaster.list,'value','space').label
                }
    }
    )}
    errorMessage={error[payload]?.[item.id]?.message}/>*/
export const InputSearchFieldA = (props) => {
/* ========================== */  
/* ========== variables ========== */  
/* ========================== */  
    const { style, defaultValue, label, register, error, disabled,width,placeholder, maxLength, } = props;
    /* ========================== */  
    /* ====== Start Render ====== */  
    /* ========================== */  
    return (
        <>
            <SinputBox style={style}>
                <Sinput
                    maxLength={maxLength}
                    defaultValue={defaultValue}
                    style={{fontSize:assets().size.baseText,height:assets().size.inputHeight,}}
                    width={width}
                    type='search'
                    placeholder={placeholder}
                    autoComplete='off'
                    {...register}
                    disabled={disabled}
                    className='inputText'
                />
                <Slabel className='inputlabelText' style ={{fontSize:assets().size.inputlabelText,top:assets().size.inputlabelTop}}>{label}</Slabel>
            </SinputBox>
            {error ? <InputErrorMessage errorMessage={error}/> : ''}
        </>
    );
};


/*  How To Use
<InputSearchFieldB
    style={{ width: '65px', marginLeft: '30px' }}
    id='code'
    label='案件コード'
    register={register}/>*/



/* ------ バリデーションなし ------ */
export const InputSearchFieldB = (props) => {
    /* ========================== */  
    /* ========== variables ========== */  
    /* ========================== */  
    const { style, id, defaultValue, label, register } = props;
    
    /* ========================== */  
    /* ====== Start Render ====== */  
    /* ========================== */  
    return (
        <>
            <SinputBox style={style}>
                <Sinput
                    id={id}
                    name={id}
                    defaultValue={defaultValue}
                    placeholder=' '
                    autoComplete='off'
                    {...register(`${id}`)}
                    className='inputText'
                    style={{fontSize:assets().size.baseText,height:assets().size.inputHeight}}
                />
                <Slabel className='inputlabelText' style ={{fontSize:assets().size.inputlabelText,top:assets().size.inputlabelTop}}>{label}</Slabel>
            </SinputBox>
        </>
    );
};
/* ------リスト型Input------ */
export const InputListSearchField = (props) => {
    /* ========================== */  
    /* ========== variables ========== */  
    /* ========================== */  
        const { placeholder, defaultValue, register, maxLength, width, disabled, label, range , errorMessage, readOnly,noDefault,list} = props;

        /* ========================== */  
        /* ====== Start Render ====== */  
        /* ========================== */
        return (
                <SinputBox >
                    <Sinput 
                        {...register} 
                        autoComplete='off'
                        maxLength={maxLength}
                        size={maxLength}
                        disabled={disabled}
                        readOnly={readOnly}
                        style={{fontSize:assets().size.baseText,height:assets().size.inputHeight,width:width}}
                        defaultValue={defaultValue}
                        placeholder={placeholder}
                        type='search'
                        list={list}
                        className='inputText'
                    />
                        <datalist id = {list}>
                        {(noDefault !== true) && <option value="" hidden>--選択--</option>}
                        {range?.map((year,i) => (
                            <SoptionRange
                                key={`${year.value}${i}`}
                                value={year.value + ' ' + year.label}
                                className='baseText'
                                style={{fontSize:assets().size.baseText}}
                            >
                            </SoptionRange>
                        ))}
                    </datalist>
                    <Slabel className='inputlabelText' style ={{fontSize:assets().size.inputlabelText,top:assets().size.inputlabelTop}}>{label}</Slabel>
                    {errorMessage ? <InputErrorMessage errorMessage={errorMessage}/> : '' }
                </SinputBox>
        );
    };



